import { Component, OnInit } from "@angular/core";
import { InvoiceCashDeskService } from "../../../services/invoice-cash-desk/invoice-cash-desk.service";
import { InvoicePatientCashDeskService } from "../../../services/invoice-cash-desk/invoice-patient-cash-desk.service";
import { InvoicePatientCreditNoteCashDeskService } from "../../../services/invoice-cash-desk/invoice-patient-credit-note-cash-desk";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'invoice-patient-credit-note-cash-desk-edit',
  templateUrl: './invoice-patient-credit-note-cash-desk-edit.component.html',
  styleUrls: ['./invoice-patient-credit-note-cash-desk-edit.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoicePatientCreditNoteCashDeskService }]
})
export class InvoicePatientCreditNoteCashDeskEditComponent implements OnInit {

  medicalappointmentid: number;


  constructor( private route: ActivatedRoute,) { }

  ngOnInit(): void {
    const params = this.route.snapshot.params;
    this.medicalappointmentid = params['AppointmentId'];
  }

  close(): void {
    history.back();
  }
}
